module.exports = {
  companies: '企業',
  catalogs: 'カタログ',
  accounts: 'アカウント',
  printers: 'プリンタ',
  login: 'ログイン',
  logout: 'ログアウト',
};



// WEBPACK FOOTER //
// ./src/lang/ja/header.js